import { __assign, __awaiter, __generator, __read, __rest } from "tslib";
import React, { useCallback, useEffect, useRef } from "react";
import classNames from "classnames";
import { View } from "../_core/components";
import VirtualList from "../_core/components/virtual-list";
import { getSystemInfoSync } from "../_core/taro";
import { callBoth } from "../_util/call-both";
import { noop } from "../_util/noop";
import { getRect } from "../_util/get-rect";
import { useIsReady } from "../_util/use-is-ready";
import { TaroEnv } from "../_util/env";
import { useConfig } from "../_util/use-config";
var getWindowHeight = function () {
    return TaroEnv === "weapp"
        ? getSystemInfoSync().windowHeight
        : window.innerHeight;
};
var defaultRender = function (_a) {
    var style = _a.style;
    return React.createElement(View, { style: style });
};
var defaultKey = function (_, index) { return index; };
export function ListView(_a) {
    var _b = _a.itemData, itemData = _b === void 0 ? [] : _b, _c = _a.itemRender, itemRender = _c === void 0 ? defaultRender : _c, _d = _a.itemSize, itemSize = _d === void 0 ? 40 : _d, _e = _a.itemKey, itemKey = _e === void 0 ? defaultKey : _e, usePageScroll = _a.usePageScroll, _f = _a.height, height = _f === void 0 ? usePageScroll ? getWindowHeight() : undefined : _f, _g = _a.width, width = _g === void 0 ? "100%" : _g, 
    // header,
    footer = _a.footer, onScroll = _a.onScroll, _h = _a.onScrollBottom, onScrollBottom = _h === void 0 ? noop : _h, _j = _a.scrollBottomThreshold, scrollBottomThreshold = _j === void 0 ? 10 : _j, useIsScrolling = _a.useIsScrolling, overscanCount = _a.overscanCount, className = _a.className, props = __rest(_a, ["itemData", "itemRender", "itemSize", "itemKey", "usePageScroll", "height", "width", "footer", "onScroll", "onScrollBottom", "scrollBottomThreshold", "useIsScrolling", "overscanCount", "className"]);
    var classPrefix = useConfig().classPrefix;
    var listRef = useRef(null);
    var listHeightRef = useRef(0);
    var ready = useIsReady();
    useEffect(function () {
        if (usePageScroll && typeof window !== "undefined") {
            listHeightRef.current = getWindowHeight() || 0;
        }
        else if (ready) {
            getRect(listRef).then(function (_a) {
                var _b = __read(_a, 1), _c = _b[0].height, height = _c === void 0 ? 0 : _c;
                listHeightRef.current = height;
            });
        }
    }, [height, usePageScroll, ready]);
    var row = useCallback(function (_a) {
        var data = _a.data, index = _a.index, props = __rest(_a, ["data", "index"]);
        return itemRender(__assign(__assign({}, props), { data: data[index] }));
    }, [itemRender]);
    var key = useCallback(function (index, data) {
        return itemKey(data[index], index);
    }, [itemKey]);
    var h5Props = {
        itemKey: key,
        usePageScroll: usePageScroll,
    };
    function handleScroll(props) {
        return __awaiter(this, void 0, void 0, function () {
            var scrollDirection, scrollOffset;
            return __generator(this, function (_a) {
                scrollDirection = props.scrollDirection, scrollOffset = props.scrollOffset;
                if (scrollDirection === "forward" &&
                    Math.ceil(scrollOffset + listHeightRef.current) >=
                        itemData.length * itemSize - scrollBottomThreshold) {
                    onScrollBottom(props);
                }
                return [2 /*return*/];
            });
        });
    }
    return (React.createElement(View, __assign({ ref: listRef, className: classNames(classPrefix + "-list-view", classNames) }, props),
        React.createElement(VirtualList, __assign({ height: height, width: width, itemData: itemData, itemCount: itemData.length, itemSize: itemSize, useIsScrolling: useIsScrolling, 
            // renderTop={header}
            renderBottom: footer, overscanCount: overscanCount, onScroll: callBoth(onScroll, handleScroll) }, h5Props), row)));
}
//# sourceMappingURL=ListView.js.map